module.exports = __webpack_public_path__ + "img/platform5.460beffd.png";